export default "__VITE_ASSET__87254720__"